import { render, staticRenderFns } from "./DocumentosSolicitud.vue?vue&type=template&id=19bea1d1"
import script from "./DocumentosSolicitud.vue?vue&type=script&lang=js"
export * from "./DocumentosSolicitud.vue?vue&type=script&lang=js"
import style0 from "./DocumentosSolicitud.vue?vue&type=style&index=0&id=19bea1d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports